import { useState } from 'react';
import api from '../../utils/api';
import { userFacingDetail } from '../../utils/errorHandler';
import { todayJST } from '../../utils/dateFormatter';

const useOpportunityEdit = (opportunity, opportunityId, setOpportunity) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState({
        profile: '',
        applicant_name: '',
        owner_id: '',
        is_closed: false,
        stage_name: '',
        close_date: ''
    });
    const [editLoading, setEditLoading] = useState(false);
    const [editError, setEditError] = useState(null);

    const handleEditDoubleClick = () => {
        if (!opportunity) return;
        setEditData({
            profile: opportunity.profile || '',
            applicant_name: opportunity.applicant_name || '',
            owner_id: opportunity.owner_id,
            is_closed: opportunity.is_closed,
            stage_name: opportunity.stage_name || '',
            close_date: opportunity.close_date || todayJST()
        });
        setIsEditing(true);
        setEditError(null);
    };

    const handleEditChange = (field, value) => {
        setEditData(prev => ({ ...prev, [field]: value }));
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditError(null);
    };

    const handleSaveEdit = async () => {
        if (!editData.applicant_name.trim()) {
            setEditError('求職者名は必須です。');
            return;
        }
        // 終了の状況で終了日を空のまま送るとサーバが 422（英語の検査の文言）を返すため、送る前に止める
        if (editData.is_closed && !editData.close_date) {
            setEditError('終了日は必須です。');
            return;
        }

        setEditLoading(true);
        setEditError(null);

        try {
            const response = await api.fetch(`/opportunities/${opportunityId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    profile: editData.profile,
                    applicant_name: editData.applicant_name,
                    owner_id: editData.owner_id,
                    stage_name: editData.stage_name || undefined,
                    close_date: editData.is_closed ? editData.close_date : null
                }),
            });
            if (!response) return; // Redirected
            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(userFacingDetail(response.status, errorData) || '更新に失敗しました。');
            }

            const updatedOpp = await response.json();
            setOpportunity(updatedOpp);
            setIsEditing(false);
            setEditLoading(false);
        } catch (err) {
            setEditLoading(false);
            setEditError(err.message);
        }
    };

    return {
        isEditing,
        editData,
        editLoading,
        editError,
        handleEditDoubleClick,
        handleEditChange,
        handleCancelEdit,
        handleSaveEdit
    };
};

export default useOpportunityEdit;
